import { AxiosInterceptorManager, InternalAxiosRequestConfig } from 'axios';

function clearParams(x: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(x).filter(([_, value]) => {
      return (
        (value !== undefined && value !== null && value !== '') ||
        (Array.isArray(value) && value.length)
      );
    }),
  );
}

export const clearEmptyParamsInterceptor = (
  manager: AxiosInterceptorManager<InternalAxiosRequestConfig>,
) =>
  manager.use((config) => {
    let params = { ...config.params };
    if (params) params = clearParams(params);

    return { ...config, params };
  });
